export default __webpack_public_path__ + "static/media/flag-ivory-coast.4b60fbed.svg";